import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule }    from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { TimeagoModule } from 'ngx-timeago';
import { ChartsModule } from 'ng2-charts';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LayoutsModule } from './layouts/layouts.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AvatarModule } from 'ngx-avatar';


import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { FaqComponent } from './pages/faq/faq.component';
import { AboutComponent } from './pages/about/about.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';

import { InMemoryDataService } from "./in-memory-data.service";
import { BrandCardAnalyticsWidgetComponent } from './widget/brand-card-analytics-widget/brand-card-analytics-widget.component';
import { TopPerformersComponent } from './widget/top-performers/top-performers.component';
import { TopDepartmentsComponent } from './widget/top-departments/top-departments.component';
import { TrendingComponent } from './widget/trending/trending.component';
import { NewConnectComponent } from './widget/new-connect/new-connect.component';
import { RecentPostCardsComponent } from './widget/recent-post-cards/recent-post-cards.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { CustomPreload } from './custom-preload.module';

import { ViewInvoiceReceiptPdfComponent } from './modules/admin/pages/view-invoice-receipt-pdf/view-invoice-receipt-pdf.component';

import { ComponentsModule } from '@app/components/components.module'

import { QRCodeModule } from 'angularx-qrcode';

//import { SafePipe } from './safe.pipe';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    FaqComponent,
    AboutComponent,
    TermsComponent,
    PrivacyComponent,
    BrandCardAnalyticsWidgetComponent,
    TopPerformersComponent,
    TopDepartmentsComponent,
    TrendingComponent,
    NewConnectComponent,
    RecentPostCardsComponent,
    ViewInvoiceReceiptPdfComponent
    //SafePipe
  ],
  imports: [
    HttpClientModule,
    /*HttpClientInMemoryWebApiModule.forRoot(
      InMemoryDataService, { dataEncapsulation: false }
    ),*/
    FormsModule, ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    TimeagoModule.forRoot(),
    ChartsModule,
    AvatarModule,
    NgbModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    NgxIntlTelInputModule,
    ComponentsModule,
    QRCodeModule
  ],
  providers: [
    CustomPreload,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
